import React, { useEffect } from 'react';
import { Box, Typography, Container, Grid, Card, CardContent, CardMedia, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { blogs } from '../data/blogs';

const Blogs = () => {
  useEffect(() => {
    document.title = "Blogs & Articles | CoreTechTalks";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", "Browse CoreTechTalks articles, expert tech insights, tutorials, and guidelines on software testing, AI tools, data quality, RAG and MCP.");
    }
  }, []);

  return (
    <Box sx={{ flexGrow: 1, py: 8, backgroundColor: '#F8FAFC' }}>
      <Container maxWidth="lg" sx={{ maxWidth: '1100px !important' }}>
        <Typography variant="h1" component="h1" sx={{ textAlign: 'center', mb: 8, fontWeight: 700, fontSize: '40px' }}>
          The CoreTechTalks Blog
        </Typography>
        <Grid container spacing={4}>
          {blogs.map((blog) => (
            <Grid size={{ xs: 12, md: 6 }} key={blog.id}>
              <Card 
                component={Link} 
                to={`/blogs/${blog.slug}`}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '100%',
                  textDecoration: 'none',
                  borderRadius: '16px',
                  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)',
                  }
                }}
              >
                {blog.image && (
                  <CardMedia
                    component="img"
                    sx={{ 
                      width: '100%', 
                      height: 200, 
                      objectFit: 'cover',
                      borderTopLeftRadius: '16px',
                      borderTopRightRadius: '16px',
                    }}
                    image={blog.image}
                    alt={blog.title}
                  />
                )}
                <CardContent sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                  <Typography variant="body2" color="primary" sx={{ fontWeight: 600, mb: 1 }}>
                    {blog.category}
                  </Typography>
                  <Typography variant="h2" component="h2" sx={{ fontSize: '22px', fontWeight: 700, color: 'text.primary', mb: 1 }}>
                    {blog.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {blog.date} &bull; {blog.author}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 3, flexGrow: 1 }}>
                    {blog.excerpt}
                  </Typography>
                  <Button 
                    variant="text" 
                    endIcon={<ArrowForwardIcon />} 
                    sx={{ p: 0, alignSelf: 'flex-start', '&:hover': { backgroundColor: 'transparent' } }}
                  >
                    Read Article
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Blogs;
